import { Injectable } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormGroupType } from '../../../../../../core/models/form-group-type';
import { GoFrequencyPairingRequest } from '../../models/go-frequency-pairing-request';
import { GoFrequencyPairingResponse } from '../../models/go-frequency-pairing-response';

@Injectable({
    providedIn: 'root',
})
export class GoFrequencyPairingFormService {
    getFrequencyDefinition(): FormGroup<
        FormGroupType<GoFrequencyPairingRequest>
    > {
        return new FormGroup<FormGroupType<GoFrequencyPairingRequest>>({
            isSelected: new FormControl<boolean>(false, [Validators.required]),
            maxFrequencyRequestId: new FormControl<number | null>(null, [
                Validators.required,
            ]),
            minFrequencyRequestId: new FormControl<number | null>(null, [
                Validators.required,
            ]),
            frequencyLow: new FormControl<number | null>(null, [
                Validators.required,
            ]),
            frequencyHigh: new FormControl<number | null>(null, [
                Validators.required,
            ]),
            frequencyType: new FormControl<string | null>(null, [
                Validators.required,
            ]),
            minFrequencyResponseId: new FormControl<number | null>(null, [
                Validators.required,
            ]),
            maxFrequencyResponseId: new FormControl<number | null>(null, [
                Validators.required,
            ]),
        });
    }

    /**
     * Patches the form value with the response. This is necessary because the API response uses different property names
     * (minFrequency/maxFrequency) than the form model (frequencyLow/frequencyHigh).
     */
    patchFormValue(
        form: FormArray<FormGroup<FormGroupType<GoFrequencyPairingRequest>>>,
        response: GoFrequencyPairingResponse[],
    ): void {
        form.patchValue(this.getFormModelValue(response));
    }

    getFormModelValue(
        response: GoFrequencyPairingResponse[],
    ): GoFrequencyPairingRequest[] {
        return response.map((frequencyPairing) => {
            return {
                ...frequencyPairing,
                frequencyLow: frequencyPairing.minFrequency,
                frequencyHigh: frequencyPairing.maxFrequency,
                frequencyType: frequencyPairing.frequencyType,
                isSelected: false,
            };
        });
    }
}
